module.exports = __webpack_public_path__ + "img/search-normal.34e119c0.svg";